const experiences = [
  // {
  //   company: 'ONE Securities Ltd.',
  //   position: 'Senior Officer & Branch In-Charge',
  //   time: '27th June 2021 - Present',
  //   logo: 'Assets/oneSecurities.png',
  // },
  {
    company: 'UCB CAPITAL MANAGEMENT LTD.',
    position: 'Senior Officer',
    time: '1st April 2018 - 12th January 2021',
    logo: 'Assets/ucb.png',
  },
  {
    company: 'SHANTA SECURITIES LTD.',
    position: 'Senior Executive',
    time: '2nd December 2016 to 1st March 2018',
    logo: 'Assets/shanta.png',
  },
  {
    company: 'MERCANTILE BANK SECURITIES LTD.',
    position: 'Senior Officer',
    time: '1st December 2015 to 1st December 2016',
    logo: 'Assets/mercantile.png',
  },
  {
    company: 'IDLC SECURITIES LTD.',
    position: 'Senior Associate',
    time: '6th October 2010 to 14th December 2015',
    logo: 'Assets/idlc.png',
  },
  {
    company: 'SHAHJALAL ISLAMI BANK LTD.',
    position: 'Trainee Officer',
    time: '1st July 2010 to 5th October 2010',
    logo: 'Assets/shahjalal.png',
  },
  {
    company: 'AB & COMPANY LTD',
    position: 'Authorized Representative',
    time: '1st March 2007 to 30 June 2010',
    logo: 'Assets/ab.png',
  },
]

export default experiences
